import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-107">
      <div className="max-w-4xl mx-auto" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-sage/5 border-2 border-sage/20 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-109">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-gold to-gold-accent" data-id="element-110"></div>

          <div className="w-20 h-20 bg-white rounded-full shadow-md flex items-center justify-center mx-auto mb-6 border border-sage/10" data-id="element-111">
            <ShieldCheck className="w-10 h-10 text-sage-dark" data-id="element-112" />
          </div>

          <h2 className="font-heading text-3xl font-bold text-dark mb-6" data-id="element-113">
            La Garantía "Cero Riesgo" de 30 Días
          </h2>

          <p className="text-lg text-dark-light leading-relaxed mb-6" data-id="element-114">
            Estoy tan segura de que este sistema cambiará tu vida que te doy un
            mes entero para probarlo. Si en 30 días no has recuperado tu energía
            o tu ropa no te queda mejor, envíame un email y te devuelvo el 100%
            de tu dinero.
          </p>

          <p className="font-bold text-dark text-xl italic" data-id="element-115">
            Sin preguntas. Y te quedas con todo el material. El riesgo es todo
            mío.
          </p>
        </motion.div>
      </div>
    </section>;
}